import { render } from "./TheVehicle.vue?vue&type=template&id=1fccab1c"
import script from "./TheVehicle.vue?vue&type=script&lang=js"
export * from "./TheVehicle.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__